import { SUPPORTED_PREFIXED_LANGS } from '@/hooks/useLang';

/**
 * Localise un chemin exprimé en français vers la langue cible.
 * - 'fr' : chemin inchangé.
 * - Autres langues : préfixe le chemin avec la langue.
 * Retire d'abord tout préfixe de langue déjà présent pour éviter les doublons.
 */
export const localizePath = (path: string, lang: string): string => {
  // Sépare l'éventuelle ancre (#...) et la query (?...) du chemin de base.
  const hashIndex = path.indexOf('#');
  const queryIndex = path.indexOf('?');
  let splitIndex = -1;
  if (hashIndex !== -1 && queryIndex !== -1) {
    splitIndex = Math.min(hashIndex, queryIndex);
  } else {
    splitIndex = hashIndex !== -1 ? hashIndex : queryIndex;
  }

  let basePath = splitIndex !== -1 ? path.slice(0, splitIndex) : path;
  const suffix = splitIndex !== -1 ? path.slice(splitIndex) : '';

  // Retire un préfixe de langue déjà présent.
  const segments = basePath.split('/');
  if ((SUPPORTED_PREFIXED_LANGS as readonly string[]).includes(segments[1])) {
    segments.splice(1, 1);
    basePath = segments.join('/') || '/';
  }

  // Français : on garde le chemin tel quel.
  if (lang === 'fr') {
    return basePath + suffix;
  }

  // Autres langues : on ajoute le préfixe.
  if (basePath === '/') {
    return `/${lang}${suffix}`;
  }

  return `/${lang}${basePath}${suffix}`;
};
